export const showNavOnScrollPosition = () => {
    const nav = document.getElementById('mainheader-mobile');
    const nav2 = document.getElementById('mainheader');
    const target = document.querySelector('.startseiten_banner');

    window.addEventListener('scroll', () => {
        const targetRect = target.getBoundingClientRect();
        if (targetRect.bottom < 100) {
            nav.classList.add('show');
            nav2.classList.add('show');
        } else {
            nav.classList.remove('show');
            nav2.classList.remove('show');
        }
    });

}
